import css from 'styled-jsx/css';

import Theme from 'styles/theme';

import { TYPES } from './constants';

const TRANSITION_DURATION = Theme.get('transition-duration-fast-ms');

/**
 * Because the styles below are exported, you cannot use dynamic styling (ie props) to generate the styles.
 * If you want conditional styling, you may do so via a BEM modifier classname.
 */

/**
 * Additionally, the export is inlined to fix a jest issue (https://github.com/zeit/styled-jsx/issues/436)
 */

export default css`
  .Button {
    font-size: 14px;
    padding: 13px ${Theme.get('spacing') * 3}px;
    cursor: pointer;
    transition: all ${TRANSITION_DURATION};
    letter-spacing: 2px;
    background-color: ${Theme.get('colors-black')};
    color: ${Theme.get('colors-white')};
    border: solid 2px ${Theme.get('colors-black')};
    text-align: center;
    text-decoration: none;
    opacity: 1;
    position: relative;
    border-radius: 2px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .Button:not(.Button--disabled):hover {
    background-color: ${Theme.get('colors-white')};
    border-color: ${Theme.get('colors-black')};
    color: ${Theme.get('colors-black')};
  }

  .Button--disabled {
    cursor: auto;
    background-color: ${Theme.get('colors-black-20')};
    border-color: ${Theme.get('colors-black-20')};
  }

  .Button--${TYPES.LINK} {
    color: ${Theme.get('colors-black')};
    background-color: transparent;
    outline: none;
    border: 0;
    padding: 0;
    text-decoration: underline;
    font-weight: 600;
    text-transform: none;
  }

  .Button--${TYPES.LINK}.focused {
    color: ${Theme.get('colors-white')};
    background-color: ${Theme.get('colors-black')};
  }

  .Button--${TYPES.LINK}.focused:after {
    display: none;
  }

  .Button--${TYPES.DARK_GRAY} {
    background-color: ${Theme.get('colors-black-80')};
    border-color: ${Theme.get('colors-black-80')};
    color: ${Theme.get('colors-white')};
  }

  .Button--${TYPES.DARK_GRAY}:not(.Button--disabled):hover {
    color: ${Theme.get('colors-black')};
    background-color: ${Theme.get('colors-white')};
    border-color: ${Theme.get('colors-white')};
  }

  .Button--${TYPES.DARK_GRAY}:not(.Button--disabled):focus {
    color: ${Theme.get('colors-black')};
    background-color: ${Theme.get('colors-white')};
    border-color: ${Theme.get('colors-white')};
  }

  .Button--${TYPES.GRAY} {
    border: 0;
    background-color: ${Theme.get('colors-grey')};
    color: ${Theme.get('colors-black')};
  }

  .Button--${TYPES.GRAY}:not(.Button--disabled):hover {
    background-color: ${Theme.get('colors-grey')};
  }

  .Button--${TYPES.OUTLINE} {
    background-color: transparent;
    border: solid 2px ${Theme.get('colors-black')};
    color: ${Theme.get('colors-black')};
  }

  .Button--${TYPES.OUTLINE}:not(.Button--disabled):hover {
    background-color: ${Theme.get('colors-black')};
    border-color: ${Theme.get('colors-black')};
    color: ${Theme.get('colors-white')};
  }

  .Button--${TYPES.INVERSE} {
    background-color: ${Theme.get('colors-white')};
    border: solid 2px ${Theme.get('colors-white')};
    color: ${Theme.get('colors-black')};
  }

  .Button--${TYPES.INVERSE}:not(.Button--disabled):hover {
    background-color: ${Theme.get('colors-black')};
    color: ${Theme.get('colors-white')};
  }

  .Button--full-width {
    width: 100%;
    display: block;
  }

  .Button--small {
    padding: ${Theme.get('spacing')}px ${Theme.get('spacing') * 2}px;
  }

  .Button--uppercase {
    text-transform: uppercase;
  }
`;
